import { Dispatch } from 'redux'

import {
  getAll,
  putResourceStatus as putResourceStatusApi
} from 'redux/api/ResourceStatuses'
import { Action } from 'types/GlobalUserEvents'
import { TResourceVariant } from 'types/GlobalResource'

import * as UserEvents from 'redux/api/internal/UserEvents'

import { useThunkActions } from 'redux/actions/useThunkActions'

import * as actions from './actions'

export function tryGetResourceStatuses(dispatch: Dispatch) {
  dispatch(actions.getResourceStatuses())

  getAll()
    .then((response) => {
      dispatch(actions.getResourceStatusesSuccess(response.data.data))
    })
    .catch(() => dispatch(actions.getResourceStatusesFailed()))
}

function tryPutResourceStatus(
  id: string,
  resourceType: TResourceVariant,
  isFavorite: boolean
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.putResourceStatus())

    putResourceStatusApi(id, resourceType)
      .then((response) => {
        if (resourceType === 'dashboard') {
          UserEvents.log({
            action: isFavorite
              ? Action.REMOVED_DASHBOARD_AS_FAVORITE
              : Action.MARKED_DASHBOARD_AS_FAVORITE,
            context: null,
            dashboard_id: null,
            dashboard_group_id: id
          })
        } else {
          UserEvents.log({
            action: isFavorite
              ? Action.REMOVED_REPORT_AS_FAVORITE
              : Action.MARKED_REPORT_AS_FAVORITE,
            context: null,
            dashboard_id: null,
            report_id: id
          })
        }

        dispatch(actions.putResourceStatusSuccess(response.data.data))
      })
      .catch(() => dispatch(actions.putResourceStatusFailed()))
  }
}

export const useResourceStatusActions = () => ({
  tryPutResourceStatus: useThunkActions(tryPutResourceStatus)
})
